import { DialogId } from '@feedyou/schema'
import { RootState } from '../../../reducers'
import { deadEndsSelector } from './deadEndsSelector'

export const isDefiniteDeadEndSelector = (state: RootState, dialogId: DialogId) => {
  return deadEndsSelector(state).definite.has(dialogId)
}
